import { CSSObject } from '@emotion/core';
import { useMemo } from 'react';

import { colors, scale, useTheme } from '@scripts/gds';
import { useFieldCSS } from '@scripts/hooks';

import { OptionsList } from '../../types';

export const DefaultOptionsList = ({
    getMenuProps,
    optionHeight,
    isOpen,
    placement = 'bottom',
    items,
    meta,
    highlightedIndex,
    selectedItem,
    getItemProps,
}: OptionsList) => {
    const { basicFieldCSS } = useFieldCSS(meta);

    const { components } = useTheme();
    // темы селекта и инпута
    const ST = components?.Select;

    const selectedOptionCSS: CSSObject = useMemo(
        () => ({
            backgroundColor: colors.backgroundMain,
            color: ST?.hoverColor,
        }),
        [ST]
    );

    return (
        <ul
            {...getMenuProps({
                css: {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    overflowY: 'auto',
                    maxHeight: optionHeight * (ST?.maxOptionsInView || 8),
                    zIndex: 100,
                    boxShadow: ST?.menuShadow,
                    borderRadius: ST?.menuBorderRadius,
                    ':focus': { outlineOffset: -2 },
                    ...(isOpen && { border: ST?.menuBorder }),
                    ...(placement === 'top' && { bottom: optionHeight }),
                    display: isOpen ? 'block' : 'none',
                },
            })}
        >
            {items.map((option, index) => (
                <li
                    key={option.value}
                    {...getItemProps({
                        item: option,
                        index,
                        css: {
                            ...basicFieldCSS,
                            padding: `${scale(1, false, 14)}px ${scale(5, true)}px`,
                            display: 'flex',
                            alignItems: 'center',
                            minHeight: optionHeight,
                            background: ST?.bg,
                            border: 'none',
                            cursor: 'pointer',
                            borderRadius: 0,
                            '&:focus, &:hover': selectedOptionCSS,
                            ...(index === highlightedIndex && selectedOptionCSS),
                            ...(option.value === selectedItem?.value && {
                                background: `${colors.backgroundMain} !important`,
                            }),
                        },
                    })}
                >
                    {option.label}
                </li>
            ))}
        </ul>
    );
};
